import React from "react";
import { TextField as MUITextField } from "@mui/material";
import styled from "styled-components";

const StyledMUITextField = styled(MUITextField)`
  fieldset {
    background: unset;
    box-shadow: unset;
    width: initial;
  }

  input[type="text"]:not(.event-datepicker):not(.MuiAutocomplete-root input) {
    border: none;
    padding-left: 16px;
  }

  input[type="number"] {
    border: none;
  }

  .MuiInputBase-root:not(.MuiAutocomplete-inputRoot):not(.Mui-disabled)
    fieldset {
    border: 1px solid var(--colorBorder) !important;
  }

  .Mui-focused:not(.MuiAutocomplete-inputRoot):not(.Mui-disabled) fieldset {
    border: 2px solid var(--primaryColor) !important;
  }

  &:hover
    .MuiInputBase-root:not(.Mui-focused):not(.MuiAutocomplete-inputRoot):not(
      .Mui-disabled
    )
    fieldset {
    border: 2px solid var(--colorBorder) !important;
  }

  .MuiInputBase-root {
    border-radius: 8px !important;
    margin: 0px;
    height: 50px;
    background-color: var(--colorPanel) !important;
    width: ${({ fullWidth }) => (fullWidth ? "100%" : "300px")};
  }
`;

export const TextField = (props) => {
  return <StyledMUITextField {...props} variant="outlined" />;
};
